import c from '../util/const';
import sapi from "../util/sapi";

import sharedActions from './shared-actions';

import Promise from 'bluebird';
import log from "../util/log";
import _ from "lodash";
import DocPermissionsHelper from "../helpers/doc-permissions-helper";
import msgHelper from "../helpers/msg-helper";
import utils from "../util/util";
import workspaceActions from "./workspace-actions";

const threadActions = {

  //pull a copy of the token cache so we can update it without updating the instance.
  copyMessageTokenCache(getState){
    return _.extend({}, _.get(getState(), 'thread.messageTokenCache'));
  },

  initThread(thread){
    return (dispatch, getState) => {
      return new Promise((resolve, reject) => {
        let activeThread = _.get(getState(), 'thread.activeThread');
        if(activeThread && thread && activeThread.chat_id === thread.chat_id){
          log.log('initThread called unnecessarily');
        }
        else{
          // log.log('thread-action initThread', thread);
          dispatch({
            type: c.actions.thread.loadingMessageBlocksId,
            messageBlocksId: thread.chat_id
          })
          dispatch({
            type: c.actions.thread.setActiveDM,
            dm: null
          })
          dispatch({
            type: c.actions.thread.setActiveThread,
            thread
          })
          dispatch({
            type: c.actions.thread.updateThreadDocs,
            docs: null
          })
          dispatch({
            type: c.actions.thread.updateThreadMessages,
            mesg_edit_flag: false,
            messages: null,
            messageBlocks: null,
            messageBlocksId : null,
            data_date: null,
          })
          dispatch({
            type: c.actions.thread.updateActiveDMDocs,
            docs: null
          })
          dispatch({
            type: c.actions.thread.updateActiveDMMessages,
            messages: null,
            messageBlocks: null,
            messageBlocksId : null,
            data_date: null
          })
        }

        return utils.waitForNextFrame()
          .then(() => {
            return dispatch(this.refreshMessagesThread())
          })
          .then((res) => {
            dispatch(this.updateContainerNotifyFlagIfNeeded());
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          })
      })
    }
  },

  initDM(dm){
    return (dispatch, getState) => {
      return new Promise((resolve, reject) => {
        let activeDM = _.get(getState(), 'thread.activeDM');
        if(activeDM && dm && activeDM.guest_uid === dm.guest_uid){
          log.log('initDM called unnecessarily');
        }
        else{
          // log.log('thread-action initDM', dm);
          dispatch({
            type: c.actions.thread.loadingMessageBlocksId,
            messageBlocksId: dm ? dm.guest_uid : null
          })
          dispatch({
            type: c.actions.thread.setActiveThread,
            thread : null
          })
          dispatch({
            type: c.actions.thread.setActiveDM,
            dm
          })
          dispatch({
            type: c.actions.thread.updateThreadDocs,
            docs: null
          })
          dispatch({
            type: c.actions.thread.updateThreadMessages,
            mesg_edit_flag: false,
            messages: null,
            messageBlocks: null,
            messageBlocksId : null,
            data_date: null
          })
          dispatch({
            type: c.actions.thread.updateActiveDMDocs,
            docs: null
          })
          dispatch({
            type: c.actions.thread.updateActiveDMMessages,
            messages: null,
            messageBlocks: null,
            messageBlocksId : null,
            data_date: null,
          })
        }

        return utils.waitForNextFrame()
          .then(() => {
            return Promise.all([
              dispatch(this.refreshMessagesDM()),
              dispatch(this.refreshDocsDM())
            ])
          })
          .then((res) => {
            dispatch(this.updateContainerNotifyFlagIfNeeded());
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          })
      })
    }
  },

  updateContainerNotifyFlagIfNeeded(){
    return (dispatch, getState) => {
      return new Promise((resolve, reject) => {
        let activeWorkspace = _.get(getState(), 'workspace.workspace');
        let activeDM = _.get(getState(), 'thread.activeDM');
        let activeThread = _.get(getState(), 'thread.activeThread');
        let activeDMDocs = _.get(getState(), 'thread.activeDMDocs');
        let activeThreadDocs = _.get(getState(), 'thread.activeThreadDocs');

        // log.log('*** updateContainerNotifyFlagIfNeeded called for dm ***', getState().thread);

        if(activeDM && _.get(activeDM, 'notify_flag')){
          let foundNotifyFlag = _.find(activeDMDocs, (doc) => doc.notify_flag);
          // log.log('*** updateContainerNotifyFlagIfNeeded called for dm ***', activeDM, activeDMDocs, foundNotifyFlag);
          if(!foundNotifyFlag){
            return dispatch(sharedActions.updateDirectMessages())
              .then(() => {
                resolve(true);
              })
          }
        }
        else if(activeWorkspace && activeThread && _.get(activeThread, 'notify_flag')){
          let foundNotifyFlag = _.find(activeThreadDocs, (doc) => doc.notify_flag);
          // log.log('updateContainerNotifyFlagIfNeeded called for thread', activeThread, activeThreadDocs, foundNotifyFlag);
          if(!foundNotifyFlag){
            return Promise.all([
                dispatch(workspaceActions.refreshWorkspace(activeWorkspace.forum_id)),
                dispatch(workspaceActions.refreshThreads(activeWorkspace.forum_id, activeWorkspace.host_uid, true))
              ])
              .then(() => {
                resolve(true);
              })
          }
        }
      })
    }
  },

  updateDocNotifyFlagAndRefresh(forum_id, host_uid, doc_id, notify_flag) {
    return (dispatch, getState) => {
      return new Promise((resolve, reject) => {
        sapi.Docs.mark(forum_id, host_uid, doc_id, notify_flag)
          .then(() => {

            let activeDM = _.get(getState(), 'thread.activeDM');
            let activeThread = _.get(getState(), 'thread.activeThread');

            if(activeDM) {
              return Promise.all([
                dispatch(this.refreshDocsDM()),
                dispatch(this.refreshMessagesDM())
              ])
            }
            else if(activeThread) {
              return dispatch(workspaceActions.refreshDocs(forum_id, host_uid))
                .then(() => {
                  return dispatch(this.refreshActiveThreadMessages());
                })
            }
          })
          .then(() => {
            //docs are refreshed, update containers if needed.
            let activeDM = _.get(getState(), 'thread.activeDM');
            let activeThread = _.get(getState(), 'thread.activeThread');

            log.log('updateDocNotifyFlagAndRefresh', activeDM, activeThread);

            if(activeDM) {
              let activeDMDocs = _.get(getState(), 'thread.activeDMDocs');
              let foundNotifyFlag = !!_.find(activeDMDocs, (doc) => doc.notify_flag);
              if(foundNotifyFlag !== activeDM.notify_flag){
                dispatch(sharedActions.updateDirectMessages())
              }
            }
            else if(activeThread){
              let activeThreadDocs = _.get(getState(), 'thread.activeThreadDocs');
              let activeWorkspace = _.get(getState(), 'workspace.workspace');

              let foundNotifyFlag = !!_.find(activeThreadDocs, (doc) => doc.notify_flag);
              if(foundNotifyFlag !== activeThread.notify_flag){
                Promise.all([
                  dispatch(workspaceActions.refreshThreads(activeWorkspace.forum_id, activeWorkspace.host_uid, true)),
                  dispatch(sharedActions.updateWorkspaces())
                ])
              }
            }

            //wait for the mark, and doc update, but not container updates.
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          })
      })
    }
  },

  clearActiveThread(){
    return (dispatch, getState) => {
      dispatch({
        type: c.actions.thread.loadingMessageBlocksId,
        messageBlocksId: null
      })
      dispatch({
        type: c.actions.thread.setActiveThread,
        thread : null
      })
      dispatch({
        type: c.actions.thread.updateThreadDocs,
        docs: null
      })
      dispatch({
        type: c.actions.thread.updateThreadMessages,
        mesg_edit_flag: false,
        messages: null,
        messageBlocks: null,
        messageBlocksId : null,
        data_date: null
      })
    }
  },

  clearActiveDM(){
    return (dispatch) => {
      dispatch({
        type: c.actions.thread.loadingMessageBlocksId,
        messageBlocksId: null
      })
      dispatch({
        type: c.actions.thread.setActiveDM,
        dm : null
      })
      dispatch({
        type: c.actions.thread.updateActiveDMDocs,
        docs: null
      })
      dispatch({
        type: c.actions.thread.updateActiveDMMessages,
        messages: [],
        messageBlocks: [],
        messageBlocksId : null,
        data_date: null
      })
    }
  },

  refreshActiveThreadMessages(useDataDate = false){
    return (dispatch, getState) => {
      log.log('thread-action refreshActiveThreadMessages', useDataDate);
      let activeThread = _.get(getState(), 'thread.activeThread');
      let activeDM = _.get(getState(), 'thread.activeDM');
      if(activeThread){
        return dispatch(this.refreshMessagesThread(useDataDate));
      }
      else if(activeDM){
        return dispatch(this.refreshMessagesDM(useDataDate));
      }
      else{
        log.warn("refresh messages called, nothing active");
        return Promise.resolve(false);
      }
    }
  },

  refreshPendingMessages(){
    return (dispatch, getState) => {
      let activeThread = _.get(getState(), 'thread.activeThread');
      let activeDM = _.get(getState(), 'thread.activeDM');
      let {accountInfo, threadTransactionQueue} = getState().shared;

      if(activeThread){
        let activeThreadMessages = _.get(getState(), 'thread.activeThreadMessages', []);
        let pendingMsgs = msgHelper.buildPendingMessageList(activeThread.chat_id, accountInfo, threadTransactionQueue);
        let messageTokenCache = this.copyMessageTokenCache(getState);
        let messageBlocks =  msgHelper.getMessageBlocks(_.concat(pendingMsgs, activeThreadMessages), messageTokenCache);
        dispatch({
          type: c.actions.thread.updateThreadMessages,
          messageBlocks: messageBlocks,
          messageTokenCache,
        })
      }
      else if(activeDM){
        let activeDMMessages = _.get(getState(), 'thread.activeDMMessages', []);
        let pendingMsgs = msgHelper.buildPendingMessageList(activeDM.guest_uid, accountInfo, threadTransactionQueue);
        //log.log('refreshing pending messages', pendingMsgs, activeDMMessages);
        let messageTokenCache = this.copyMessageTokenCache(getState);
        let messageBlocks =  msgHelper.getMessageBlocks(_.concat(pendingMsgs, activeDMMessages), messageTokenCache);
        dispatch({
          type: c.actions.thread.updateActiveDMMessages,
          messageBlocks: messageBlocks,
          messageTokenCache,
        })
      }
      else{
        log.warn("refresh messages called, nothing active");
      }
    }
  },

  filterPendingResultWithServerData(messagesFromServer, pendingMessages){
    // log.log('thread-action filterPendingResultWithServerData', messagesFromServer, pendingMessages);
    let pendingMessageResults = [];
    _.each(pendingMessages, (pendingMessage) => {
      if (pendingMessage.isCompleteTransaction) {
        let foundMesgId = _.find(messagesFromServer, (msg) => msg.mesg_id === pendingMessage.mesg_id);

        //If we found the completed message in the response, then we're done, this message has been fully committed.
        if(!foundMesgId) {
          pendingMessageResults.push(pendingMessage);
        }
      }
      else{
        pendingMessageResults.push(pendingMessage);
      }
    })
    // log.log('thread-action  filterPendingResultWithServerData', pendingMessageResults, messagesFromServer, pendingMessages)
    return pendingMessageResults;
  },

  clearFinishedTransactions(messagesFromServer, threadTransactionQueue){
    return (dispatch, getState) => {
      let finishedTransactionIds = [];
      _.each(threadTransactionQueue, (txn) => {
        if (txn.isComplete) {
          let foundMesgId = _.find(messagesFromServer, (msg) => msg.mesg_id === txn.mesg_id);
          //If we found the completed message in the response, then we're done, this message has been fully committed.
          if(foundMesgId) {
            finishedTransactionIds.push(txn.transaction_id);
          }
        }
      })

      _.each(finishedTransactionIds, (txn_id) => {
        dispatch(sharedActions.clearTransaction(txn_id));
      })
    }
  },

  refreshMessagesDM(useDataDate){
    return (dispatch, getState) => {
      return new Promise((resolve, reject) => {

        let activeDM = _.get(getState(), 'thread.activeDM');
        if(!activeDM){
          log.warn("refreshMessagesDM called when dm not active");
          resolve(true);
          return;
        }

        let data_date = null;
        if(useDataDate){
          data_date = _.get(getState(), 'thread.activeDMDataDate');
        }

        sapi.DM.messages(activeDM.guest_uid, data_date)
          .then((res) => {

            //this check is important and a little subtle.
            //we're pulling fresh loadingMessageBlocksId, but checking against the local version of activeThread
            //if something has changed, we bail here.
            let loadingMessageBlocksId = _.get(getState(), 'thread.loadingMessageBlocksId');
            if(!loadingMessageBlocksId || !activeDM || loadingMessageBlocksId !== activeDM.guest_uid){
              log.log("refreshMessagesDM thread has changed since load", activeDM.guest_uid, loadingMessageBlocksId);
              resolve(false);
              return;
            }

            let {accountInfo, threadTransactionQueue} = getState().shared;
            let pendingMsgs = msgHelper.buildPendingMessageList(activeDM.guest_uid, accountInfo, threadTransactionQueue);
            let messageTokenCache = this.copyMessageTokenCache(getState);

            if (data_date) {
              let foundIds = [];
              let newMsgs = _.get(res, 'data.mesg_data', []);
              let existingMsgs = _.get(getState(), 'thread.activeDMMessages', []);
              let combinedMsgs = [];
              _.each(existingMsgs, (existingMsg) => {
                let found = _.find(newMsgs, (newMsg) =>  {
                  return newMsg.mesg_id === existingMsg.mesg_id
                })
                if (found) {
                  foundIds.push(found.mesg_id);
                  combinedMsgs.push(found);
                }
                else {
                  combinedMsgs.push(existingMsg);
                }
              })

              //Add all the new messages that we haven't added yet.
              _.each(newMsgs, (msg) => {
                if(foundIds.indexOf(msg.mesg_id) < 0){
                  combinedMsgs.push(msg);
                }
              })

              let msgs = msgHelper.formatMessageSigningDataForLegacyIfNeeded(combinedMsgs);
              pendingMsgs = this.filterPendingResultWithServerData(msgs, pendingMsgs);
              let messageBlocks = msgHelper.getMessageBlocks(_.concat(pendingMsgs, combinedMsgs), messageTokenCache);
              dispatch({
                type: c.actions.thread.updateActiveDMMessages,
                messages: msgs,
                messageBlocks: messageBlocks,
                messageBlocksId : activeDM.guest_uid,
                data_date: res.data.data_date,
                messageTokenCache,
              })
              dispatch(this.clearFinishedTransactions(msgs, threadTransactionQueue))
            }
            else {
              let msgs = msgHelper.formatMessageSigningDataForLegacyIfNeeded(_.get(res, 'data.mesg_data', []))
              pendingMsgs = this.filterPendingResultWithServerData(msgs, pendingMsgs);
              let messageBlocks =  msgHelper.getMessageBlocks(_.concat(pendingMsgs, msgs), messageTokenCache);
              dispatch({
                type: c.actions.thread.updateActiveDMMessages,
                messages: msgs,
                messageBlocks: messageBlocks,
                messageBlocksId : activeDM.guest_uid,
                data_date: res.data.data_date,
                messageTokenCache,
              })
              dispatch(this.clearFinishedTransactions(msgs, threadTransactionQueue))
            }

            resolve(res);
          })
          .catch((err) => {
            reject(err);
          })
      })
    }
  },

  updateThreadReadlog(forum_id, host_uid, chat_id){
    return (dispatch, getState) => {
      sapi.Threads.updateReadlog(forum_id, host_uid, chat_id)
        .catch((err) => {
          log.log('error updating readlog', err);
        })
    }
  },

  refreshMessagesThread(useDataDate){
    return (dispatch, getState) => {
      return new Promise((resolve, reject) => {
        let activeWorkspace = _.get(getState(), 'workspace.workspace');
        let activeThread = _.get(getState(), 'thread.activeThread');

        if(!activeWorkspace){
          log.warn("refreshMessagesThread called when ws not active");
          resolve(true);
          return;
        }

        if(!activeThread){
          log.warn("refreshMessagesThread called when thread not active");
          resolve(true);
          return;
        }

        let data_date = null;
        if(useDataDate){
          data_date = _.get(getState(), 'thread.activeThreadDataDate');
        }

        Promise.all([
          sapi.Threads.messages(activeWorkspace.forum_id, activeWorkspace.host_uid, activeThread.chat_id, data_date, true)
        ])
          .then((res) => {

            //this check is important and a little subtle.
            //we're pulling fresh loadingMessageBlocksId, but checking against the local version of activeThread
            //if something has changed, we bail here.
            let loadingMessageBlocksId = _.get(getState(), 'thread.loadingMessageBlocksId');
            if(!loadingMessageBlocksId || !activeThread || loadingMessageBlocksId !== activeThread.chat_id){
              log.log("refreshMessagesThread thread has changed since load");
              resolve(false);
              return;
            }

            let threadDocs = _.get(getState(), 'workspace.docs', []);
            let foundChatBlock = _.find(threadDocs, (chatBlock) => chatBlock.chat_id === activeThread.chat_id);
            let foundChatDocs = (foundChatBlock && foundChatBlock.docs) ? foundChatBlock.docs : [];

            let {accountInfo, threadTransactionQueue} = getState().shared;
            let pendingMsgs = msgHelper.buildPendingMessageList(activeThread.chat_id, accountInfo, threadTransactionQueue);
            let messageTokenCache = this.copyMessageTokenCache(getState);

            if (data_date) {
              let foundIds = [];
              let newMsgs = _.get(res[0], 'data.mesg_data', [])
              if(newMsgs.length > 0){
                //If we passed data_date, and got something new, then we need to mark the readlog
                let threadForumId = _.get(activeWorkspace, 'forum_id');
                let threadHostuid = _.get(activeWorkspace, 'host_uid');
                let threadChatId = _.get(activeThread, 'chat_id');
                dispatch(this.updateThreadReadlog(threadForumId, threadHostuid, threadChatId));
              }

              let existingMsgs = _.get(getState(), 'thread.activeThreadMessages', []);
              let combinedMsgs = [];
              _.each(existingMsgs, (existingMsg) => {
                let found = _.find(newMsgs, (newMsg) => {
                  return newMsg.mesg_id === existingMsg.mesg_id
                })
                if (found) {
                  foundIds.push(found.mesg_id);
                  combinedMsgs.push(found);
                }
                else {
                  combinedMsgs.push(existingMsg);
                }
              })

              //Add all the new messages that we haven't added yet.
              _.each(newMsgs, (msg) => {
                if (foundIds.indexOf(msg.mesg_id) < 0) {
                  combinedMsgs.push(msg);
                }
              })

              let msgs = msgHelper.formatMessageSigningDataForLegacyIfNeeded(combinedMsgs)
              pendingMsgs = this.filterPendingResultWithServerData(msgs, pendingMsgs);
              let messageBlocks = msgHelper.getMessageBlocks(_.concat(pendingMsgs, combinedMsgs), messageTokenCache);
              dispatch({
                type: c.actions.thread.updateThreadMessages,
                mesg_edit_flag: res[0].data.mesg_edit_flag,
                messages: msgs,
                messageBlocks: messageBlocks,
                messageBlocksId: activeThread.chat_id,
                data_date: res[0].data.data_date,
                messageTokenCache,
              })
              dispatch({
                type: c.actions.thread.updateThreadDocs,
                docs: foundChatDocs
              })
              dispatch(this.clearFinishedTransactions(msgs, threadTransactionQueue))
            }
            else {

              //no need to wait for the readlog to update.  Just fire it off.
              let threadForumId = _.get(activeWorkspace, 'forum_id');
              let threadHostuid = _.get(activeWorkspace, 'host_uid');
              let threadChatId = _.get(activeThread, 'chat_id');
              dispatch(this.updateThreadReadlog(threadForumId, threadHostuid, threadChatId));

              let msgs = msgHelper.formatMessageSigningDataForLegacyIfNeeded(_.get(res[0], 'data.mesg_data', []));
              pendingMsgs = this.filterPendingResultWithServerData(msgs, pendingMsgs);
              let messageBlocks = msgHelper.getMessageBlocks(_.concat(pendingMsgs, msgs), messageTokenCache);
              dispatch({
                type: c.actions.thread.updateThreadMessages,
                mesg_edit_flag: res[0].data.mesg_edit_flag,
                guest_data : _.get(res[0], 'data.guest_data', {}),
                messages: msgs,
                messageBlocks: messageBlocks,
                messageBlocksId: activeThread.chat_id,
                data_date: res[0].data.data_date,
                messageTokenCache,
              })
              dispatch({
                type: c.actions.thread.updateThreadDocs,
                docs: foundChatDocs
              })
              dispatch(this.clearFinishedTransactions(msgs, threadTransactionQueue))
            }

            resolve(res[0]);
          })
          .catch((err) => {
            reject(err);
          })
      })
    }
  },

  refreshDocsDM(){
    return (dispatch, getState) => {
      return new Promise((resolve, reject) => {
        // log.log('thread-action refreshDocsDM');
        let activeDM = _.get(getState(), 'thread.activeDM');
        if(!activeDM){
          log.warn("refreshDocsDM called when dm not active");
          resolve(true);
          return;
        }

        sapi.DM.docList(activeDM.guest_uid)
          .then((res) => {

            //this check is important and a little subtle.
            //we're pulling fresh loadingMessageBlocksId, but checking against the local version of activeThread
            //if something has changed, we bail here.
            let loadingMessageBlocksId = _.get(getState(), 'thread.loadingMessageBlocksId');
            if(!loadingMessageBlocksId || !activeDM || loadingMessageBlocksId !== activeDM.guest_uid){
              log.log("refreshDocsDM thread has changed since load");
              resolve(false);
              return;
            }

            let docs = [];
            _.each(res.data, (block) => {
              _.each(block.docs, (doc) => {
                doc.$chatId = block.chat_id;
                docs.push(doc);
              })
            })
            dispatch({
              type: c.actions.thread.updateActiveDMDocs,
              docs: docs
            })
            resolve(docs);
          })
          .catch((err) => {
            log.log('refresh dm doc list err', err);
            reject(err);
          })
      })
    }
  },

  cleanup(){
    return {
      type: c.actions.thread.cleanup
    }
  },

  mapToDispatch(dispatch) {
    return {
      initThread : (thread) => dispatch(this.initThread(thread)),
      initDM : (dm) => dispatch(this.initDM(dm)),
      clearActiveThread : () => dispatch(this.clearActiveThread()),
      clearActiveDM : () => dispatch(this.clearActiveDM()),
      refreshActiveThreadMessages : (useDataDate) => dispatch(this.refreshActiveThreadMessages(useDataDate)),
      refreshDocsDM : () => dispatch(this.refreshDocsDM()),
      refreshPendingMessages : () => dispatch(this.refreshPendingMessages()),
      updateDocNotifyFlagAndRefresh : (forum_id, host_uid, chat_id, notify_flag) => dispatch(this.updateDocNotifyFlagAndRefresh(forum_id, host_uid, chat_id, notify_flag)),
      cleanup : () => dispatch(this.cleanup())
    }
  }
}

export default threadActions;
